// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SiteSettingPanel_wrapper__23FgU","link":"SiteSettingPanel_link__14cmI"};